import { useTranslation } from "react-i18next";

import { useInsights } from "@/api/insights";
import { PageHeader } from "@/components/page-header";
import { Empty, EmptyDescription, EmptyHeader } from "@/components/ui/empty";
import { ItemGroup } from "@/components/ui/item";
import { Skeleton } from "@/components/ui/skeleton";

import { InsightItem } from "./InsightItem";

export default function Insights() {
  const { t } = useTranslation();
  const { data: insights } = useInsights();

  return (
    <div className="flex flex-col gap-6">
      <PageHeader title={t("insights.title")} />
      {!insights ? (
        <Skeleton className="h-40 w-full" />
      ) : insights.length === 0 ? (
        <Empty>
          <EmptyHeader>
            <EmptyDescription>{t("insights.empty")}</EmptyDescription>
          </EmptyHeader>
        </Empty>
      ) : (
        <ItemGroup className="gap-2">
          {insights.map((insight) => (
            <InsightItem key={insight.id} insight={insight} />
          ))}
        </ItemGroup>
      )}
    </div>
  );
}
